module.exports = __webpack_public_path__ + "img/girl-speaking.f90ea7b6.svg";